var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mapGetters, mapMutations } from "vuex";
import { trim } from "lodash";
import Message from "./chat/Message";
export default {
    name: "ChatPanel",
    components: {
        Message: Message,
    },
    data: function () {
        return {
            message: "",
            messageTextareaFocus: false,
        };
    },
    computed: __assign(__assign({}, mapGetters(["showChat", "chatMessages"])), { noMessages: function () {
            return this.chatMessages.length === 0;
        } }),
    methods: __assign(__assign({}, mapMutations(["setChatPanelOpened"])), { sendMessage: function (event) {
            if (event.shiftKey) {
                return;
            }
            var trimmedMessage = trim(this.message);
            if (trimmedMessage == "")
                return;
            this.$socket.sendWithoutSession("sendChatMessage", {
                content: trimmedMessage,
            });
            this.message = "";
            this.autoResize();
        },
        closeChatPanel: function () {
            this.setChatPanelOpened(false);
        },
        scrollToLastMessage: function () {
            var container = this.$refs["chat-content"];
            container.scrollTop = container.scrollHeight;
        },
        autoResize: function (event) {
            var _this = this;
            var messageTextarea = this.$refs["chat-message"];
            setTimeout(function () {
                messageTextarea.style.cssText = "height:auto; padding:0";
                var height = messageTextarea.scrollHeight;
                if (height > 48)
                    height = 48;
                if (event === undefined || event.shiftKey || event.keyCode !== 13) {
                    messageTextarea.style.cssText = "height:" + height + "px";
                }
                _this.scrollToLastMessage();
            });
        } }),
    watch: {
        chatMessages: function () {
            setTimeout(this.scrollToLastMessage, 0);
        },
        showChat: function (newValue) {
            if (newValue)
                setTimeout(this.scrollToLastMessage, 0);
        },
    },
    mounted: function () {
        this.scrollToLastMessage();
    },
};



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/ChatPanel.vue
// module id = 325
// module chunks = 1